export const VIDM_STATUS = {
  REVISED: 'revised',
  REJECTED: 'rejected',
  APPROVED: 'approved',
  NOT_GENRETED: 'it note generated',
};
